import { endPoints, requestType } from "../constants/variables";
import Api from "./index";

const getForms = () => {
  return Api(endPoints.getForms, requestType.GET);
};

const createForm = (params) => {
  return Api(endPoints.createForm, params, requestType.POST);
};

const updateForm = (id, params) => {
  return Api(`${endPoints.updateForm}/${id}`, params, requestType.PUT);
};

const deleteForm = (id) => {
  return Api(`${endPoints.deleteForm}/${id}`, null, requestType.DELETE);
};

const getFormById = (id) => {
  return Api(`${endPoints.getFormById}/${id}`, null, requestType.GET);
};

const getSubmittedForms = (page = 1, limit = 10) => {
  return Api(
    `${endPoints.getSubmittedForms}?page=${page}&limit=${limit}`,
    null,
    requestType.GET
  );
};

export { getForms, createForm, updateForm, deleteForm, getFormById, getSubmittedForms };